export default "__VITE_ASSET__wz5WkBZ$__"